import { useTranslations } from "@/hooks/useTranslations";
import { DropdownMenu } from "radix-ui";
import { useSortBy, type UseSortByProps } from "react-instantsearch";

export function SortBy(props: UseSortByProps) {
	const { currentRefinement, options, refine,canRefine } = useSortBy(props);
	const tc = useTranslations();
	const currentLabel = options.find(option => option.value === currentRefinement);
	const handleRefine = (value: string) => {
		if (value !== currentRefinement && canRefine) {
			refine(value);
		}
	};
	return (
		<DropdownMenu.Root>
			<DropdownMenu.Trigger asChild>
				<button className={"ais-dropdownMenu__trigger ais-sortBy"} aria-label={tc.sortItems}>
					<span className={"ais-sortBy__label"}> {currentLabel?.label}</span>
					<i className={"icon icon-angle-down ais-sortBy__arrowIcon"} aria-hidden={true} />
				</button>
			</DropdownMenu.Trigger>
			<DropdownMenu.Portal>
				<DropdownMenu.Content className={"ais-dropdownMenu__content"} sideOffset={5} align={"end"}>
					<DropdownMenu.RadioGroup className={"ais-dropdownMenu__group"} value={currentRefinement} onValueChange={handleRefine}>
						{options.map(option => (
							<DropdownMenu.RadioItem key={option.value} value={option.value} className={"ais-dropdownMenu__item"}>
								<DropdownMenu.ItemIndicator className={"ais-dropdownMenu__itemIndicator"}>
									<i className={"icon icon-check"} aria-hidden={true} />
								</DropdownMenu.ItemIndicator>
								{option.label}
							</DropdownMenu.RadioItem>
						))}
					</DropdownMenu.RadioGroup>
					<DropdownMenu.Arrow className={"ais-dropdownMenu__arrow"} />
				</DropdownMenu.Content>
			</DropdownMenu.Portal>
		</DropdownMenu.Root>
	);
}
